import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/redux/store';
import {
  actions,
  selectors,
} from 'src/routes/IndividualDashboard/modules/dashboard/slice';
import { selectors as loggedInUserSelectors } from 'src/redux/data/loggedInUser';
import { displayInTimezone, FORMAT_WITHOUT_SECONDS } from 'src/utils/timeUtils';

const mapStateToProps = (state: RootState) => {
  const metadata = selectors.selectTrendingOverviewMetadata(state);
  const timeFrame = selectors.selectTimeFrame(state);
  const timezone = loggedInUserSelectors.getUserTenantTimezone(state);
  const chartData = selectors.selectTrendingOverviewChartData(state);
  const startTimeWithTz = timeFrame.startTime
    ? displayInTimezone(timeFrame.startTime, timezone, FORMAT_WITHOUT_SECONDS)
    : '';
  const endTimeWithTz = timeFrame.endTime
    ? displayInTimezone(timeFrame.endTime, timezone, FORMAT_WITHOUT_SECONDS)
    : '';

  return {
    isLoading: metadata.isLoading,
    patientId: selectors.getCurrentPatientId(state),
    data: chartData,
    positionChanges: selectors.selectTrendingOverviewPositionChanges(state),
    hrBaseline: metadata.hrContinuousBaseline,
    rrBaseline: metadata.rrContinuousBaseline,
    stepSize: metadata.stepSize,
    unit: metadata.unit,
    timeFrame: `${startTimeWithTz} - ${endTimeWithTz}`,
    startTime: timeFrame.startTime,
    endTime: timeFrame.endTime,
    dataPoints: metadata.dataPointsCount,
    timezone,
  };
};

const mapActionCreators = {
  getPatientMetricData: actions.getPatientMetricData,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
